import app from './app'
import contact from './contact'
import orders from './orders'
import user from './user'

export default { user, orders, contact, app }
